// Header.js
import React, { useState, useEffect } from "react";
import manito_header from "../../assets/main/manito_header.png";
import userIconSvg from "../../assets/header/user.svg";
import { Link, useNavigate } from "react-router-dom";
import LoginModal from "../../components/auth/LoginModal";

import './Header.css';

const Header = () => {
  const API_BASE_URL = process.env.REACT_APP_API_URL;

  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [isUserMenuOpen, setIsUserMenuOpen] = useState(false);

  // Usuario logueado setear foto
  const [user, setUser] = useState(null);
  const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);
  
  // Detectar el fondo de la seccion para cambiar la clase al dropdown del header
  const [headerTheme, setHeaderTheme] = useState("light"); 

  const toggleMenu = () => setIsOpen(!isOpen);
  const handleUserEnter = () => setIsUserMenuOpen(true);
  const handleUserLeave = () => setIsUserMenuOpen(false);
  const navigate = useNavigate();

  const handleLogout = async () => {
    await fetch(`${API_BASE_URL}/auth/logout.php`, {
      credentials: "include"
    });

    setUser(null);
    window.location.reload();
  };

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    fetch(`${API_BASE_URL}/auth/me.php`, {
      method: "GET",
      credentials: "include"
    })
      .then(res => res.json())
      .then(data => {
        if (data.status === "success") {
          setUser(data.user);
        } else {
          setUser(null);
        }
      })
      .catch(() => setUser(null));
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      const sections = document.querySelectorAll("section");
      let currentTheme = "light";

      sections.forEach(section => {
        const rect = section.getBoundingClientRect();
        if (rect.top <= 100 && rect.bottom >= 100) {
          if (section.classList.contains("section-green")) {
            currentTheme = "light"; 
          } else {
            currentTheme = "dark"; 
          }
        }
      });

      setHeaderTheme(currentTheme);
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll(); 
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      <header className={`header-container ${scrolled ? "scrolled" : ""}`}>
        <div className="container">
          <div className="header-content">
            <div className="logo_header">
              <img 
                src={manito_header} 
                alt="One Learning Logo" 
                style={{ cursor: 'pointer' }}
                onClick={() => {
                  if (window.location.pathname === "/") {
                    window.scrollTo({ top: 0, behavior: "smooth" });
                  } else {
                    navigate("/");
                  }
                }} 
              />
            </div>

            <button className="hamburger" onClick={toggleMenu}>
              ☰
            </button>

            {/* Nav normal (Desktop) */}
            <nav className="nav-menu">
              <ul>
                <li><Link to="/">Nosotros</Link></li>
                <li><Link to="/servicios">Servicios</Link></li>
                <li><Link to="/cursos">Cursos</Link></li>
                
                <li
                  className="user-menu-wrapper"
                  onMouseEnter={handleUserEnter}
                  onMouseLeave={handleUserLeave}
                >
                  <div className="user-icon-btn">
                    {user && user.photo_url ? (
                      <img
                        src={user.photo_url}
                        alt="Perfil"
                        className="user-photo"
                      />
                    ) : (
                      <img
                        src={userIconSvg}
                        alt="Perfil"
                        className="custom-user-svg"
                      />
                    )}
                  </div>

                  {isUserMenuOpen && (
                    <div className={`user-dropdown ${headerTheme}`}>
                      {!user ? (
                        <Link
                          className="dropdown-item"
                          onClick={() => setIsLoginModalOpen(true)}
                        >
                          Login
                        </Link>
                      ) : (
                        <>
                          <Link to="/" className="dropdown-item">Inicio</Link>
                          <Link to="/mis-cursos" className="dropdown-item">Mis cursos</Link>
                          <Link to="/mi-perfil" className="dropdown-item">Mi perfil</Link>
                          {/* <Link to="/mi-carrito" className="dropdown-item">Mi carrito</Link> */}
                          <Link
                            className="dropdown-item"
                            onClick={handleLogout}
                          >
                            Cerrar sesión
                          </Link>
                        </>
                      )}
                    </div>
                  )}
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </header>

      {/* Sidebar para móviles */}
      <div className={`sidebar ${isOpen ? "open" : ""}`}>
        <button className="close-btn" onClick={toggleMenu}>
          ✕
        </button>
        <nav className="sidebar-menu">
          <ul>
            <li><Link to="/" onClick={toggleMenu}>Nosotros</Link></li>
            <li><Link to="/servicios" onClick={toggleMenu}>Servicios</Link></li>
            <li><Link to="/cursos" onClick={toggleMenu}>Cursos</Link></li>
            
            <hr style={{ borderColor: 'rgba(255,255,255,0.2)', margin: '15px 0' }} />
            
            {/* Opciones de usuario agregadas para versión móvil */}
            {!user ? (
              <li>
                <a onClick={() => { setIsLoginModalOpen(true); toggleMenu(); }}>
                  Login
                </a>
              </li>
            ) : (
              <>
                <li><Link to="/mis-cursos" onClick={toggleMenu}>Mis cursos</Link></li>
                <li><Link to="/mi-perfil" onClick={toggleMenu}>Mi perfil</Link></li>
                {/* <li><Link to="/mi-carrito" onClick={toggleMenu}>Mi carrito</Link></li> */}
                <li>
                  <a onClick={() => { handleLogout(); toggleMenu(); }}>
                    Cerrar sesión
                  </a>
                </li>
              </>
            )}
          </ul>
        </nav>
      </div>

      {isOpen && <div className="overlay" onClick={toggleMenu}></div>}
      
      <LoginModal 
        isOpen={isLoginModalOpen} 
        onClose={() => setIsLoginModalOpen(false)} 
      />
    </>
  );
};

export default Header;